import { dayjs } from './dayjs'

export function clockTrans() {
  return {
    toModel: state => ({
      hour: state ? state.hour : null,
      minute: state ? state.minute : null,
      second: state ? state.second : null,
    }),
    toState: model => ({
      hour: model ? model.hour : null,
      minute: model ? model.minute : null,
      second: model ? model.second : null,
    }),
  }
}

export function getDatetimTrans(format = 'YYYY-MM-DD HH:mm:ss') {
  return () => ({
    toModel: state => (state ? dayjs(state).format(format) : null),
    toState: model => {
      if (!model) {
        return null
      }
      return dayjs(model)
    },
  })
}

export function getDateRangeTrans(format = 'YYYY-MM-DD') {
  return () => ({
    toModel: state => ({
      start: state.start ? state.start.format(format) : null,
      end: state.end ? state.end.format(format) : null,
    }),
    toState: model => ({
      start: model.start ? dayjs(model.start) : null,
      end: model.end ? dayjs(model.end) : null,
    }),
  })
}

export function getDateTrans(format = 'YYYY-MM-DD') {
  return () => ({
    toModel: state => (state ? state.format(format) : null),
    toState: model => {
      if (model) {
        return dayjs(model)
      }
      return null
    },
  })
}

export function getDateListTrans(format = 'YYYY-MM-DD') {
  return () => ({
    toModel: state => {
      if (state) {
        return state.map(d => d.format(format))
      }
      return []
    },
    toState: model => {
      if (model) {
        return model.map(m => dayjs(m))
      }
      return []
    },
  })
}
